import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import "./index.css";

const CountdownTimer = ({ targetDateTime, hideTimer, countdownData }) => {
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  function calculateTimeRemaining() {
    const now = new Date();
    const targetDate = new Date(targetDateTime);
    const difference = targetDate - now;

    if (difference <= 0) {
      return null;
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    return { days, hours, minutes, seconds };
  }

  const pad = v => (v == null ? "00" : String(v).padStart(2, "0"));

  return (
    <div className="CountdownTimer">
      <h2 className="cdt-heading">{countdownData?.heading}</h2>
      <div className="cdt-description">
        {ReactHtmlParser(countdownData?.countdownDescription)}
      </div>
      <p className="cdt-subheading">{countdownData?.subheading}</p>

      <div className="timerContent">
        <>
          <div className="cdt-timer-value">
            {pad(timeRemaining?.days || "00")} <span>Days</span>
          </div>
          <div className="cdt-timer-value">
            {pad(timeRemaining?.hours || "00")} <span>Hours</span>
          </div>
          <div className="cdt-timer-value">
            {pad(timeRemaining?.minutes || "00")} <span>Minutes</span>
          </div>
          <div className="cdt-timer-value">
            {pad(timeRemaining?.seconds || "00")} <span>Seconds</span>
          </div>
        </>
        {!timeRemaining && (
          <p className="cdt-deal-live" onClick={hideTimer}>
            <span>Unlock exclusive deals here</span>
          </p>
        )}
      </div>

      <div className="cdt-logos">
        {countdownData?.partners?.map((partner, index) => (
          <a
            key={index}
            href={partner?.partnerLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={partner?.partnerLogo?.sourceUrl}
              alt={partner?.partnerLogo?.altText || `Partner Logo ${index + 1}`}
              className="cdt-logo"
            />
          </a>
        ))}
      </div>
    </div>
  );
};

export default CountdownTimer;
